import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Drop-in replacement for `<Input type="password">` with an eye toggle that
 * reveals the typed value. Behaves identically to a plain Input so existing
 * `value`, `onChange`, `placeholder`, `data-testid`, etc., pass straight
 * through; we just wrap it in a relative container and overlay a button.
 *
 * The toggle button never submits the surrounding form (`type="button"`) and
 * exposes its own `data-testid={testId}-eye` for tests.
 */
export default function PasswordInput({ "data-testid": testId, className = "", ...rest }) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <Input
                {...rest}
                type={show ? "text" : "password"}
                className={`pr-10 ${className}`}
                data-testid={testId}
            />
            <button
                type="button"
                onClick={() => setShow((s) => !s)}
                tabIndex={-1}
                aria-label={show ? "Hide password" : "Show password"}
                title={show ? "Hide password" : "Show password"}
                className="absolute inset-y-0 right-0 px-3 flex items-center text-muted-foreground hover:text-foreground transition-colors"
                data-testid={testId ? `${testId}-eye` : undefined}
            >
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
        </div>
    );
}
